/* eslint-disable */
export const AccordionSection = ({
  title,
  id,
  children,
  onSectionToggle,
  activeSections,
  collapsedArrowIcon,
  expandedArrowIcon,
}) => {
  const isExpanded = activeSections && activeSections[id] === true;
  const titleId = `map-biglayerpanel-accordion-title-${id}`;
  const panelId = `map-biglayerpanel-accordion-panel-${id}`;

  return (
    <>
      <button
        aria-expanded={isExpanded}
        className="leaflet-biglayerpanel-accordion-title"
        id={titleId}
        aria-controls={panelId}
        onClick={() => onSectionToggle(id)}
      >
        <img src={isExpanded ? expandedArrowIcon : collapsedArrowIcon} alt="" aria-hidden="true" />
        {title}
      </button>
      <div
        className={`leaflet-biglayerpanel-accordion-section ${isExpanded ? '' : 'collapsed'}`}
        id={panelId}
        aria-labelledby={titleId}
      >
        <fieldset>
          <legend></legend>
          {children}
        </fieldset>
      </div>
    </>
  );
};

export const LayerItem = ({
  layerId,
  label,
  swatchStyle,
  swatchType = 'circle',
  hasLabels = false,
  subpanel = null,
  stackingOrder,
  isActive = false,
  isLabelsActive = false,
  onToggle = () => {},
  onLabelsToggle = () => {},
}) => {
  return (
    <div className="leaflet-biglayerpanel-layer" data-layer-id={layerId} data-layer-stacking={stackingOrder}>
      <div className="leaflet-biglayerpanel-layer-left">
        <div className="checkbox-item">
          <input
            type="checkbox"
            name="overlays"
            value={layerId}
            id={`leaflet-biglayerpanel-layer-${layerId}`}
            checked={isActive}
            onChange={(e) => onToggle(layerId, e.target.checked)}
          />
          <label tabIndex="0" htmlFor={`leaflet-biglayerpanel-layer-${layerId}`}>
            {swatchStyle && (
              <div
                className={`leaflet-biglayerpanel-layer-swatch leaflet-biglayerpanel-layer-swatch-${swatchType}`}
                style={swatchStyle}
              ></div>
            )}
            {label}
          </label>
        </div>

        {subpanel && <div className="leaflet-biglayerpanel-layer-subpanel">{subpanel}</div>}
      </div>

      {hasLabels && (
        <div className="leaflet-biglayerpanel-layer-right">
          <div className="checkbox-item">
            <input
              type="checkbox"
              name="overlays"
              value={`${layerId}-labels`}
              id={`leaflet-biglayerpanel-layer-${layerId}-labels`}
              checked={isLabelsActive}
              onChange={(e) => onLabelsToggle(`${layerId}-labels`, e.target.checked)}
            />
            <label tabIndex="0" htmlFor={`leaflet-biglayerpanel-layer-${layerId}-labels`}>
              Labels
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export const SwatchLegendItem = ({ backgroundColor, borderColor, text, type = 'circle', style = {} }) => (
  <>
    <div
      className={`leaflet-biglayerpanel-layer-swatch leaflet-biglayerpanel-layer-swatch-${type}`}
      style={{ backgroundColor, borderColor, ...style }}
    ></div>
    {text}
    <br />
  </>
);
